module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h11"
  }, [_vm._v("II")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "t4"
  }, [_vm._v("ARSHALL")]), _vm._v(" "), _c('span', {
    staticClass: "t4"
  }, [_vm._v("SENTIT")]), _vm._v(" un balancement avant même de reprendre connaissance. Il ne s’agissait pas du mouvement d’un navire et il ne percevait pas l’odeur de la mer. Malgré sa migraine lancinante, il entrouvrit les yeux et constata qu’il était couché sur le dos, avec un panneau de bois juste au-dessus de lui – bien trop près : à trente centimètres à peine. La lumière atténuée qui passait à travers les fentes des planches, aussi bien derrière sa tête que sur le côté, annonçait la fin d’après-midi. Des grains de poussière y flottaient. Il n’était pas sur un bateau, plutôt dans une sorte de chariot alors ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Il tourna la tête à droite et vit le capitaine Smith, apparemment inconscient. Archer, les yeux fermés, gisait à sa gauche. Marshall roula sur le côté et voulut secouer le capitaine. Quand une chaîne l’empêcha de bouger le bras, il retrouva bel et bien ses esprits.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Un faible mouvement s’esquissa derrière lui.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Will ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Il se retourna vers Archer")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Davy. Est-ce que tout va bien ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— J’ai repris connaissance, grinça Archer, mais pour le moment, je préfère ne pas ouvrir les yeux. Tant que je ne regarde pas, rien n’est encore réel.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Un jour, Archer s’était retrouvé coincé entre les panneaux de la coque de la "), _c('span', {
    staticClass: "t5"
  }, [_vm._v("Calypso")]), _vm._v(" après une violente bataille en mer. Il avait fallu des heures pour le libérer d’un trou à peu près de la taille d’un cercueil, et une demi-heure de plus pour le ranimer. Il avait bien failli mourir asphyxié. Depuis lors, il avait la phobie des espaces clos.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Cela vous rappelle ce malheureux incident lorsque vous avez été coincé dans l’entrepont, n’est-ce pas ? Je pense n’avoir jamais vraiment compris ce qu’était la claustrophobie avant aujourd’hui.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Morbleu, cela ne me le rappelle que trop ! répliqua Archer d’une voix étranglée. Will, je ne sais pas combien de temps je vais pouvoir tenir…")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Marshall s’étira et réussit à atteindre sa main. Elle était glacée, mais sa poigne était d’acier.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Tenez bon, Davy. Ils n’ont certainement pas l’intention d’aller très loin. Respirez profondément.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Pourquoi ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Marshall eut un sourire triste.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Je n’en ai aucune idée. Mais mon père avait l’habitude de donner ce conseil à ses paroissiens quand ils avaient des ennuis. D’après lui, le Seigneur a ainsi insufflé la vie à Adam et nous n’avons que trop tendance à ignorer ce don. Respirer, d’après mon père, est une forme d’apaisement. Et c’est efficace, je le reconnais, du moins quand je pense à le faire.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Le plus difficile est toujours de se souvenir de ce qu’il faut faire, n’est-ce pas ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Marshall l’entendit respirer profondément, plusieurs fois, à titre expérimental.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Je pense que votre père avait raison, reprit Archer. Au moins, cela m’occupe l’esprit.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Sa voix paraissait un peu plus calme à présent, sa main plus détendue.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Vous devriez essayer de dormir, Davy, conseilla Marshall. Je vais monter la garde jusqu’à ce que le capitaine se réveille.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Est-il blessé ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Je ne sais pas, je ne peux pas l’atteindre. Capitaine ? Capitaine Smith ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Smith remua la tête et émit un son entre gémissement et grognement.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— M. Marshall. M. Archer, êtes-vous là ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Oui, monsieur.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Depuis combien de temps sommes-nous dans cette fichue boîte, M. Marshall ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Je n’en sais trop rien, monsieur. Nous avons tous été assommés avant d’être faits prisonniers. La lumière a changé depuis que j’ai repris connaissance, il y a une quinzaine de minutes environ. Je pense que le soleil ne va pas tarder à se coucher.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Mmm.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Je leur ai demandé s’ils étaient français, monsieur. Ils ont paru trouver ma question très divertissante.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— C’est bon à savoir.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Marshall vit son capitaine faire, comme lui-même précédemment, une rapide reconnaissance de son environnement.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Au moins une heure, peut-être plus, conclut-il. Nous avons été attaqués deux heures avant le coucher du soleil.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Oui, monsieur. Il fait beaucoup plus sombre.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Il parlait encore lorsque les dernières lueurs du jour disparurent. Marshall eut une idée macabre : il savait à présent ce qu’on éprouvait en étant enterré vivant. Pourtant, l’air ne manquait pas, il avait vu la lumière à travers les fissures du bois, mais l’obscurité était oppressante. La main d’Archer s’était à nouveau contractée sur la sienne.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Smith réfléchissait à haute voix.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Apparemment, il y a peu de circulation. Nous pourrions essayer de crier pour attirer l’attention si quelqu’un approchait, mais je présume que nous aurions été bâillonnés si nos ravisseurs s’inquiétaient que nous soyons entendus.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Il fit cliqueter ses chaînes.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Cela me semble solide, remarqua-t-il. Et vous, M. Archer, avez-vous plus de liberté avec vos liens ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Aucune, monsieur.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Morbleu. Eh bien, messieurs, je considère cette mésaventure comme un exercice formateur. Il semble que nous avons tous à améliorer notre vigilance. Je sais que nous courons le risque d’être entendus, mais je vais pourtant vous donner mes ordres. Si vous voyez une chance de vous évader, n’hésitez pas. Faites-le. Je fais confiance à votre bon sens. Ne courez pas de risques inutiles. Je crois avoir compris la situation.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Surpris, Marshall cligna des yeux.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Monsieur ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— J’ai reçu récemment, comme tous les hauts gradés, une dépêche qui m’avertissait d’une vague d’enlèvements commis par une bande d’hommes masqués. Ils réclament des rançons. J’ai veillé à ce que ma famille soit discrètement protégée, mais il ne m’est jamais venu à l’esprit que ces brigands auraient l’inconscience d’enlever plusieurs officiers de la Royal Navy. Ils découvriront vite avoir commis une grave erreur.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Oui, monsieur.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Effectivement, une telle audace paraissait stupide. Pourtant, ils étaient tous les trois prisonniers et le processus de leur détention était des plus efficaces.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Smith se racla la gorge.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— M. Archer, votre père, le comte, ne sera pas content d’apprendre que vous êtes dans un si mauvais pas.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Non, monsieur, mais je pense qu’il paiera néanmoins ma rançon, répliqua David, avec sarcasme. Ils ne peuvent réclamer très cher pour un troisième fils, je présume.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— N’évaluez pas votre valeur en fonction de votre rang de naissance, M. Archer. Quant à vous, M. Marshall, ajouta-t-il en baissant la voix, vous serez jusqu’à nouvel ordre le fils de ma défunte cousine, mariée au révérend Marshall.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Monsieur ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— D’après ce que je sais, si ce gang reçoit la rançon exigée, les prisonniers sont rendus vivants à leurs familles, parfois plusieurs semaines plus tard. Ils sont déposés à terre à des kilomètres de l’endroit où ils ont été enlevés. Ils ignorent où ils ont été retenus captifs, à part qu’ils se trouvaient sur un bateau. Malheureusement, si la cible visée n’a pas les moyens de racheter sa liberté, elle est retrouvée morte, ou disparaît à jamais. Vous aurez davantage d’importance aux yeux de nos ravisseurs avec de hautes relations familiales. Bien entendu, dans le cas où nous ne parviendrions pas à nous évader, je veillerai à payer vos deux rançons.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Très touché, Marshall déglutit.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Monsieur, je… je ne pourrai jamais vous rembourser.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Je serais grièvement insulté si vous tentiez de le faire, lieutenant, grommela Smith. Si mon rang vous a mis en danger, ma responsabilité est de vous faire sortir sain et sauf de cette mésaventure.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Oui, monsieur.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Bien. Pour le moment, autant nous reposer et monter la garde, car il semble que nous n’ayons pas d’alternative. Je prends le premier quart, je vous réveillerai ensuite, M. Marshall, et vous secouerez M. Archer, quand ce sera son tour. Nous prendrons des quarts de deux heures, à estimer de votre mieux.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Oui, monsieur. Merci, monsieur.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Marshall s’étendit, aussi confortablement que possible sur le parquet de bois brut. Il écouta Archer contrôler sa respiration et attendit pour s’endormir que celui-ci lui lâche la main. Il n’espérait pas vraiment se détendre, mais entre sa longue journée, sa migraine persistante et le balancement monotone du chariot, la fatigue l’emporta sur son activité mentale et lui permit de somnoler.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Il se réveilla en sursaut en entendant Smith hurler à son oreille. Il n’eut pas le temps de capter les mots exacts de son capitaine. Une trappe s’ouvrit au-dessus d’eux et une lame menaçante fut pressée contre sa gorge. Il déglutit et resta totalement immobile.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Vous avez intérêt à vous taire, murmura une voix, sinon je vous tranche la gorge, en commençant par le plus jeune. C’est bien compris ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Absolument, répondit Smith.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Le panneau se referma avec un claquement sec, les aspergeant tous les trois de poussière.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— J’ai entendu un cavalier approcher, expliqua le capitaine. Un de leurs complices, je le crains.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Dois-je à présent prendre mon tour de garde, monsieur ? s’enquit Marshall.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— C’est inutile, M. Marshall. Je n’ai aucunement envie de dormir. Notre voyage dure depuis un certain temps déjà, à allure régulière. Nous avons pu parcourir vingt-cinq ou trente kilomètres, mais j’ignore si nous longeons la côte vers le nord ou vers le sud. S’ils envisagent de nous faire monter à bord d’un navire, les plages discrètes permettant un débarquement clandestin ne manquent pas.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Pensez-vous qu’ils soient de mèche avec les contrebandiers, monsieur ? demanda Marshall.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Oui, c’est probable. Ce chariot a de toute évidence été conçu pour transporter de la contrebande, qu’il s’agisse de marchandises ou de prisonniers.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Oui, monsieur, c’est exact.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— M. Archer ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Monsieur ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Il semble que nous soyons autorisés à converser jusqu’à notre arrivée à destination. J’ai donc l’intention de vous faire réviser les questions susceptibles de vous être posées à votre examen au grade de lieutenant.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Il s’adressa à Marshall :")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— M. Marshall, si vous voulez exercer vos connaissances, n’hésitez pas, mais je vous prie de ne pas exprimer vos réponses à voix haute.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Puis le capitaine revint au jeune sous-lieutenant :")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— M. Archer, une voile est en vue. Que feriez-vous en premier lieu pour tenter de déterminer si ce navire est ami ou ennemi ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Par ‘ennemi’, vous voulez dire français, monsieur ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Effectivement.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Dans ce cas, le premier signe révélateur d’un bâtiment français serait d’avoir trois mâts de même hauteur. Je vérifierais également si la voile n’est pas excessivement propre, vu que leurs navires passent l’essentiel de leur temps au port. Dans tous les cas, je me préparerais à considérer qu’il s’agit d’un ennemi, puisque les Français usent des navires anglais capturés en mer comme nous le faisons également avec les leurs.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Très bien. Quels sont les points positifs et négatifs du bateau sur lequel vous naviguez actuellement ? Comment utiliseriez-vous ses points forts pour compenser ses faiblesses ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Tandis que l’examen se poursuivait, Marshall commença à se demander si Smith n’avait pas feint un peu plus tôt d’être inconscient. Le capitaine semblait comprendre qu’Archer avait besoin d’une distraction. Concentrer l’attention d’Archer sur son prochain examen s’avérait une stratégie efficace : non seulement il avait la chance de se préparer – aussi difficiles que puissent être les conditions de l’épreuve, la situation ne serait jamais pire qu’actuellement – mais il recevait également un message sous-jacent d’espoir, l’assurance tacite que le capitaine ne perdrait ni son temps ni celui d’Archer s’il n’était pas certain que le jeune homme survivrait et passerait son examen.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("D’un autre côté, pensa Marshall avec consternation, le capitaine était très capable d’agir ainsi pour renforcer le moral de ses lieutenants. Il était préférable d’agir, sous quelque forme que ce soit, que de rester immobile, impuissant et inquiet. La distraction fonctionnait également pour Marshall, permettant à son esprit de s’envoler ailleurs, même si son corps restait confiné. Et il fut ravi de découvrir qu’Archer était éminemment prêt à passer son examen – en tout cas, à son humble avis. Les questions de Smith variaient du ridiculement simple – par exemple, la définition d’une drisse – au très complexe.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Une question lui parut tout à coup familière :")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Vous avancez par bâbord, face à un fort vent de nord-est, avec Douvres à trois lieues au nord. Le vent vire brusquement et vous prend au dépourvu.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("C’était à cause de cette question que Marshall avait échoué à son premier examen – il n’était devenu lieutenant qu’au deuxième essai. Apparemment, Davy avait aussi de la difficulté à répondre, puisqu’il ne répondait pas du tac au tac.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Voilà que vous avez démâté, M. Archer, continuait Smith, avec des falaises de Douvres sous le vent. Qu’allez-vous faire ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Naufrage")]), _vm._v(", pensa Marshall. Il devait pourtant y avoir une réponse ! Bien qu’il ait eu quelques idées, il avait toujours été trop gêné pour aborder le sujet, surtout avec son capitaine ou M. Drinkwater, qui savaient peut-être ce que cherchaient les examinateurs. Grâce au ciel, il avait su répondre aux questions de son deuxième examen, sinon il serait encore dans le dortoir des aspirants.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— M. Archer ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Puis-je demander une précision, monsieur ? s’enquit Davy d’un ton hésitant.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Le jour de votre examen, ce serait mal avisé. N’avez-vous pas compris la question ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Si, monsieur, la question est assez claire. Mais pourquoi mener un navire aussi près de Douvres ? Le vent est dangereux par là-bas, avec la façon dont les falaises plongent…")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Exactement")]), _vm._v(". Marshall avait eu cette remarque sur la langue le jour de son examen. Quel imbécile risquerait son navire en se fiant au vent sur cette côte rocheuse et abrupte, un des endroits les plus dangereux qui soient ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— C’est exact, M. Archer. Vous ne commettriez pas une telle erreur, mais supposons que votre commandant ait pris une mauvaise décision et qu’il ait été assommé lorsque les mâts sont tombés. Vous n’avez pas mis votre bateau dans cette position dangereuse, mais vous êtes désormais l’officier supérieur responsable du navire et de l’équipage. Vous devez les sauver. Quels sont vos ordres, monsieur ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Je… je virerais à tribord en maintenant la voilure, j’ajouterais une voile de plus, si j’en avais le temps, et je filerais autant que possible sous le vent, pour m’éloigner des falaises.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Bravo, Davy !")]), _vm._v(" Le félicita Marshall en son for intérieur. Cela pourrait marcher…")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Et si le vent tournait encore et vous rabattait vers la côte ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Davy fit une pause, le temps d’inspirer profondément.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Je plongerais une ancre, monsieur, et même deux si possible…")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Vous avez perdu une de vos ancres quand un Français a tenté de vous couper la route pendant le quart de nuit. Vous n’avez pas eu le temps de la remplacer. La seconde ancre se bloque à mi-course et réduit votre manœuvrabilité, mais pas suffisamment pour ralentir votre dérive vers les falaises. Que faites-vous à présent ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("N’y avait-il aucune réponse à cette fichue question ? Marshall était aussi frustré qu’Archer.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Après un moment, ce dernier répondit :")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Je suis désolé, monsieur, mais… j’enverrais une annexe à terre avec un rouleau de cordages, j’établirais une aussière et je donnerais l’ordre de préparer à abandonner le navire. Je réalise bien que ma réponse n’est pas satisfaisante, mais je ne vois pas…")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Non, M. Archer, répondit Smith. Vous avez raison.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Monsieur ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Nous détestons tous devoir l’admettre, dit le capitaine, mais il existe des circonstances où un capitaine n’a pas le choix. Parfois, il faut se décider au pire. Parce que le destin est sans pitié.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Ses mots résonnèrent dans l’obscurité et y laissèrent un écho.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Voyez-vous, reprit-il, c’est la façon dont nous nous comportons dans de telles conditions qui marque la différence entre une ignominieuse défaite et une victoire finale. Ce cas a bel et bien existé, il y a maintenant plusieurs années que la question revient régulièrement durant les examens. Son but est de rappeler à nos jeunes officiers trop confiants qu’ils restent soumis à leur limitation humaine.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Le capitaine se tourna vers Marshall pour conclure :")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— En vérité, M. Marshall, votre difficulté à répondre à ce petit problème n’a pas été retenue contre vous, après tout.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Il ne m’est jamais venu à l’idée qu’il pouvait ne pas exister de réponse, monsieur, reconnut Marshall. Mes félicitations, M. Archer.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Smith se racla la gorge.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Voyons maintenant une question qui a une réponse. Vous venez d’échouer sur un banc de boue à l’embouchure d’un port occupé par des forces ennemies. Quelle est la méthode préconisée pour libérer votre vaisseau et comment comptez-vous le défendre durant le processus ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Les questions continuèrent pendant une heure ou deux, jusqu’à ce que la voix profonde du capitaine se fatigue.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Une dernière question, messieurs, et gardez-la bien en tête jusqu’à notre libération : vous avez été enlevés par des inconnus, dans le but présumé de vous extorquer une rançon. Comment comptez-vous vous libérer, ainsi que vos compagnons de bord, dans les meilleures conditions possible, en particulier en capturant vos ravisseurs ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Entrée complémentaire, HMS")]), _vm._v(" Calypso"), _c('span', {
    staticClass: "t5"
  }, [_vm._v(", en réparation, Portsmouth.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Lieutenant-commandant Anthony Drinkwater, capitaine remplaçant.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("17 juillet 1799")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("À 16 heures")]), _vm._v(", "), _c('span', {
    staticClass: "t5"
  }, [_vm._v("le capitaine Smith, le lieutenant Marshall, et le sous-lieutenant Archer ont quitté le navire pour aller à terre et vérifier, avec le charpentier du port, le temps que prendraient les réparations de")]), _vm._v(" la Calypso"), _c('span', {
    staticClass: "t5"
  }, [_vm._v(". Ils devaient remonter à bord à 20 heures, mais je n’ai depuis reçu aucune nouvelle du capitaine. C’est très inhabituel. En vérité, c’est bien la première fois à ma souvenance que le capitaine Smith manque de ponctualité. J’ai donc envoyé le quartier-maître Korthals s’enquérir de ce qui se passait. Il m’a fait son rapport à 21 h 15, à savoir que le capitaine ne s’était jamais présenté à son rendez-vous avec le charpentier. J’ai renvoyé M. Korthals à terre, accompagné de trois membres de notre équipage (Barrow, O’Reilly et Klingler), en les chargeant d’enquêter sur le sort de nos officiers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("M")]), _c('span', {
    staticClass: "t4"
  }, [_vm._v("ARSHAL")]), _vm._v(" "), _c('span', {
    staticClass: "t4"
  }, [_vm._v("PRIT")]), _vm._v(" le premier tour de guet. Il laissa les autres dormir bien après l’heure du changement de quart, ce dont il profita pour réfléchir à ce qui venait de leur arriver, à leur capture. Sans doute aurait-il pu faire quelque chose. Mais quoi ? S’il le déterminait, peut-être aurait-il une meilleure idée de ce qu’il lui faudrait faire ensuite. Il finit par décider que seul un pistolet aurait pu le sortir d’affaire, même s’il n’en portait pas d’ordinaire avec son uniforme. À présent, il était trop tard.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Il commençait à se demander s’il n’était pas resté trop longtemps confiné. Il sentait à nouveau la mer. Pourquoi, alors qu’il ne l’avait pas remarqué jusque-là ? Leurs ravisseurs s’étaient-ils d’abord rendus à terre pour éviter les soupçons ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Marshall se demandait encore s’il devait réveiller Smith lorsque son dilemme fut résolu.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Le bruit du roulement des roues se modifia, car la voiture retrouvait une route pavée, et le changement de rythme éveilla la capitaine.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Tout est calme, M. Marshall ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Jusqu’à présent, monsieur.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Smith huma l’air.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Et nous sommes de retour sur la côte. Ça ne devrait pas tarder à présent. Eh bien, M. Marshall, voyez-vous une solution à notre problème ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Je n’ai que des regrets, monsieur. Nous aurions bien eu besoin d’un pistolet.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Nous en porterons à l’avenir. Morbleu ! Je ne peux comprendre qu’un bandit soit assez stupide pour enlever des officiers de la Royal Navy sans penser aux représailles ! Ces inconscients ne réalisent-ils pas que l’Angleterre est une île ? C’est à nous qu’ils doivent d’être protégés !")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Marshall fut surpris d’une telle véhémence. Le capitaine évoquait presque l’Angleterre comme une femme de chair et de sang. D’un autre côté, la forte personnalité de Smith et sa farouche volonté étaient ce qui unissait son équipage en une formation de combat animée d’une seule âme.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Je présume que non, monsieur. Et même si c’est le cas, ils n’en tiennent pas compte.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Effectivement. Vous devriez prendre du repos, M. Marshall.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Cette fois-ci, cependant, le sommeil ne vint pas. Après avoir longuement parcouru les routes cahoteuses, les bruits extérieurs changèrent. La voiture s’arrêta, les harnais tintèrent, les chevaux tapèrent du pied. Puis le voyage reprit jusqu’à un nouvel arrêt. La trappe s’ouvrit et révéla le toit d’une autre grange, faiblement éclairée par deux lanternes.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Quelqu’un brandit une lumière au-dessus des prisonniers.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Fin du trajet, "), _c('span', {
    staticClass: "t5"
  }, [_vm._v("boyos")]), _vm._v(", déclara le porte-parole de l’homme masqué qui les avait capturés. Descendez un par un. Soyez sages et vous retournerez bientôt sains et saufs à votre vaisseau.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Il posa son couteau contre la gorge de Marshall avant d’indiquer :")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Vous passez le premier, capitaine.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Deux autres bandits s’occupaient de Smith lorsqu’Archer demanda à mi-voix :")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Où sommes-nous ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Je ne sais pas, répondit Marshall d’un ton prudent, espérant que l’homme au couteau ne serait pas trop pressé de le manier. Nous avons atteint la prochaine étape de notre petit voyage, apparemment.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— C’est exact, déclara son ravisseur. Encore un petit effort et vous serez à nouveau embarqués. À vous, maintenant.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Il braqua son couteau sur Archer pendant que Marshall était libéré de ses fers. Ce dernier étira son dos douloureux, le cœur serré. Ils étaient cernés par au moins huit ennemis, la plupart armés de gourdins. Le capitaine Smith, mains attachées dans le dos, fut introduit dans un baril, du même genre que ceux qu’ils utilisaient à bord pour stocker la nourriture.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Maintenant, n’ayez pas dans l’idée que ça arrive chaque fois, déclara le bandit bavard. Je me suis juste dit que des barils de biscuits conviendraient bien à des marins, mais nous utilisons un moyen différent pour chacun de nos prisonniers. Rentrez là-dedans.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Des barils ? répéta Archer.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Parfaitement. Il y a des trous qui font passer l’air, vous ne vous asphyxierez pas. Pourtant, n’oubliez pas que s’il y a du bruit dans le baril, nous le jetterons par-dessus bord.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Smith, poussé vers le tonneau, jeta à Marshall un tel regard que celui-ci faillit en plaindre les pirates. Peu après, l’œil mauvais du capitaine disparut quand le couvercle se referma. Marshall se sentit soudain très inquiet. Comment Davy allait-il supporter ce confinement ? Pourrait-il garder son calme ? Il le faudrait bien. Il n’y avait aucune chance que les bandits tiennent compte de sa phobie, même si Marshall tentait de la leur expliquer. De plus, il ne pouvait humilier son ami de cette façon.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Il descendit de la voiture sous le regard attentif de ses ravisseurs, puis se laissa lier les mains et enfermer dans un baril. Celui où se trouvait Smith était déjà hissé sur un chariot qui en contenait plusieurs autres, tous identiques, et sans doute remplis de biscuits parfaitement ordinaires.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Ne mets pas le couvercle avant que nous ayons saucissonné le dernier.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Ils arrachèrent Archer à son réduit. Le jeune homme regarda autour de lui, aperçut le dernier tonneau encore vide et croisa les yeux de Marshall. Ce dernier, constatant sa panique, s’efforça de parler d’un ton léger :")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Eh bien, Davy, quelle histoire nous aurons à raconter un jour à nos petits-enfants, n’est-ce pas ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Archer déglutit, puis réussit à esquisser un sourire contraint tandis que les bandits le ligotaient.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— La p-prochaine fois, ils nous feront sans doute passer par le trou d’une serrure.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("La plaisanterie aurait été plus convaincante si sa voix n’avait pas tremblé. Une main saisit Marshall par l’épaule.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Entrez là-dedans.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Il résista le temps de dire :")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("— Pensez aux falaises de Douvres, Davy. Respirez bien régulièrement.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Puis la main le força à l’intérieur et le couvercle retomba sur sa tête, le plongeant dans le noir. Il entendit des coups de marteau et ferma les yeux. Davy avait raison : cela rendait les choses un peu plus faciles. Pourtant, il garda l’oreille aux aguets tandis que sa petite prison se balançait et avançait jusqu’à être déposée sur le chariot. Puis il y eut un choc contre son tonneau. Archer, probablement. Dès que le reste de la cargaison fut chargé, le chariot se mit en route, cahin-caha.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Respire, espèce d’idiot")]), _vm._v(". Il fit l’effort de décontracter ses muscles et tenta de suivre le conseil qu’il avait donné à Archer. Il aurait voulu marteler le couvercle de ses poings et exiger qu’on le laisse sortir à l’air libre. Il n’osa pas. Il était probable qu’il se ferait tuer. Et même si ce n’était pas le cas, il risquait de souhaiter être mort. Et si lui était dans un tel état, comment diable Davy s’en sortait-il ?")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Marshall laissa retomber sa tête contre les parois de bois. S’il était de guet, en haut du mât de hune, à savourer la solitude à la fraîche, son perchoir ne serait guère plus grand. Il évoqua une nuit nuageuse, sans lune, tout aussi sombre… mais il y aurait le souffle du vent et "), _c('span', {
    staticClass: "t5"
  }, [_vm._v("la Calypso")]), _vm._v(", même à l’ancre, se balancerait. Les quatre heures de sa garde, du milieu de la nuit jusqu’à l’aube, passeraient comme l’éclair. Et ici, il n’était pas seul, pas vraiment. Archer se trouvait juste à côté de lui et le capitaine Smith un peu plus loin.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Les images familières l’ayant un peu détendu, Marshall aurait voulu pouvoir partager avec Davy ce moyen de détente. Du coup, il recommença à s’inquiéter. "), _c('span', {
    staticClass: "t5"
  }, [_vm._v("Non.")]), _vm._v(" Davy s’en sortirait. Il était plus solide qu’il le pensait. Il traverserait cette épreuve sans dommages. Tous trois le feraient.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Et ils trouveraient également la réponse à la dernière question du capitaine. Marshall ne savait pas encore comment, mais quand ils seraient enfin devant leur mystérieux ennemi – qu’il haïssait déjà – ils trouveraient le moyen de le contrer.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Entrée complémentaire, HMS")]), _vm._v(" Calypso"), _c('span', {
    staticClass: "t5"
  }, [_vm._v(", en réparation, Portsmouth.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("Lieutenant-commandant Anthony Drinkwater, capitaine remplaçant.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t5"
  }, [_vm._v("17 juillet 1799")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t13"
  }, [_vm._v("Notre groupe de recherche est revenu. Le capitaine Smith et ses deux compagnons ont dîné à l’Ancre, dont ils sont repartis vers 18 h 30. Peu après, ils ont été vus monter dans une calèche en compagnie d’un lieutenant du port, que nous avons été incapables de localiser ou d’identifier. Les trois éclaireurs ont demandé l’autorisation de retourner à terre pour enquêter, ce que je leur ai accordé, car ce sont des marins-artilleurs venant des équipages commandés par M. Marshall et M. Archer. Tous ont démontré une grande loyauté vis-à-vis de ces jeunes et remarquables officiers. Je crois qu’il n’y a aucun risque de désertion. En outre, ils auront accès à une population qui serait fermée à la plupart des officiers. Nous espérons tous le prochain retour de nos hommes, sains et saufs, mais j’ai déjà prévenu les autorités portuaires de leur disparition. De ce fait, l’amiral Roberts a ordonné la fouille de tous les navires au port depuis 15 h 30 cet après-midi. D’après les rapports de ses commis, aucun lieutenant ne correspond à la description de l’homme ayant été aperçu avec nos camarades. L’amiral a exprimé sa crainte que ces disparitions inexpliquées soient liées à une récente série d’enlèvements. Il semble peu probable que des bandits aient la témérité de s’en prendre à nos officiers, mais aucun des ravisseurs, bien sûr, ne peut connaître le capitaine Smith aussi bien que nous. Cependant, il y a dix-huit mois, un très riche capitaine marchand a justement été enlevé dans ce même port, donc les bandits connaissent bien les lieux. J’ai armé de pistolets notre groupe d’enquêteurs. La loyauté de l’équipage est telle que de nombreux hommes se sont portés volontaires pour participer aux recherches. J’ai accordé la permission de se rendre à terre à tous ceux que je crois dignes de confiance. (Voir liste ci-jointe).")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t15"
  }, [_vm._v("L")]), _c('span', {
    staticClass: "t16"
  }, [_vm._v("E")]), _vm._v(" "), _c('span', {
    staticClass: "t16"
  }, [_vm._v("TRAJET")]), _vm._v(" "), _c('span', {
    staticClass: "t14"
  }, [_vm._v("s’avéra plus bref que Marshall ne l’avait prévu. Après quelques minutes à peine sur le chariot, son baril fut déchargé à quai, puis embarqué – sur un canot assez petit, s’il devait en juger à son balancement excessif ; l’embarcation était mal équilibrée. La dernière partie du voyage, le transbordement sur le navire, fut la pire, mais elle ne dura guère. Cela signifiait probablement qu’ils se trouvaient dans un port, car un repaire de contrebandiers réclamerait une très longue distance depuis une plage discrète jusqu’à l’endroit où attendrait un bateau ancré. Portsmouth étant le seul port important de la région, tous les villages des environs étaient à exclure, l’embarquement aurait eu lieu depuis la plage ou l’estuaire. Donc, ils étaient sans doute revenus à Portsmouth. C’était une ruse intelligente de les ramener au port où ils avaient été enlevés : tous les navires à l’ancre avaient d’ores et déjà été fouillés.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Après quelques minutes fort désagréables le temps que les barils soient montés à bord, Marshall sentit à nouveau la solidité familière d’un pont. Les voix étouffées qu’il entendait à travers le chêne de son tonneau ressemblaient à celles de tout équipage normal veillant à l’embarquement d’une cargaison. Puis une nouvelle voix tonna au-dessus des autres.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Bonsoir, messieurs.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Quelques coups résonnèrent sur son tonneau. Suivirent deux autres, non loin de là, qui lui indiquèrent la proximité de ses compagnons.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Bienvenue à bord de mon brave bateau, l’")]), _c('span', {
    staticClass: "t13"
  }, [_vm._v("Insaisissable")]), _c('span', {
    staticClass: "t14"
  }, [_vm._v(", même si, bien entendu, ce n’est pas le nom actuellement inscrit sur sa proue. Je suis le capitaine. Vous pouvez m’appeler ‘capitaine Adrian’ ou ‘monsieur’. Mes hommes vont à présent vous escorter dans vos quartiers. Capitaine Smith, si tout se passe bien, vous ne reverrez pas vos hommes avant la fin de notre séjour parmi nous. J’ai appris par expérience que mes hôtes, une fois séparés, sont bien moins enclins à tenter de s’évader. Vous noterez que j’ai dit ‘tenter’, car ils n’y réussissent jamais. Je descendrai vous rendre visite une fois que vous serez installés.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Il n’était pas surprenant que Smith soit gardé à l’écart, pourtant, Marshall avait espéré le contraire. Il eut peu de temps pour le regretter, car son tonneau fut soulevé et roulé au bas d’une volée de marches. Les brigands étaient astucieux et ne prenaient pas le risque qu’on puisse apercevoir des officiers sortir d’un baril depuis la terre ou les navires à proximité. De plus, ils ne laissaient à leurs prisonniers aucune chance d’examiner les caractéristiques du bateau-pirate.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Lorsque tout mouvement s’arrêta enfin, il y eut un grincement d’outil métallique forçant le couvercle du baril. Lorsque ce dernier sauta, le tonneau fut renversé une fois de plus et Marshall s’en trouva éjecté. Il tomba sur le pont. Non loin de lui, deux marins masqués s’attaquaient avec des barres de fer au couvercle d’un second baril.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Je vous salue, déclara la voix qu’il avait entendue au pont supérieur. Êtes-vous Marshall ou Archer ?")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Marshall.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Il se remit maladroitement sur pieds pour faire face à son ravisseur. En vérité, il n’aperçut qu’une silhouette, l’étroit passage étant éclairé par une simple lanterne, placée derrière l’homme. Celui-ci paraissait relativement jeune, la trentaine environ, à une ou deux années près, et solidement bâti.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Capitaine… Adrian ? reprit Marshall.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("L’homme inclina brièvement la tête. Marshall vit alors que lui aussi portait un masque qui lui cachait les yeux, tandis qu’une barbe rousse dissimulait le reste de son visage.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— À votre service.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Pardonnez-moi, mais j’en doute fort.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Doutez si cela vous chante. A-t-il été fouillé ? demanda le capitaine à ses hommes.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Oui, monsieur, répondit l’un d’eux. Deux fois. Nous avons trouvé sur lui une épée, un coutelas, du silex et de l’amadou, une livre, deux shillings et quatre pence.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Vous avez bien raison de ne pas emporter davantage pour vous rendre à terre, lieutenant. On ne sait jamais sur quel malandrin l’on peut tomber. Qu’est-ce qui ne va pas avec celui-là ? Il respire, au moins ?")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Les deux hommes venaient d’ouvrir le couvercle du baril de Davy. Mais rien ne bougeait à l’intérieur. Marshall tendit le cou pour mieux voir, essayant de rester impassible et de dissimuler son inquiétude.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Oui, monsieur, juste évanoui.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Dès qu’Adrian hocha la tête, les deux hommes renversèrent le tonneau et Archer roula sur le sol, inerte.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Aspirant ? appela Adrian en le poussant du bout du pied.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Sous-lieutenant, corrigea Marshall.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Il n’apercevait aucune trace de sang. Que diable ces brutes avaient-elles fait à son ami ?")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Bien, voyez si vous pouvez le convaincre de reprendre connaissance. Il aura peut-être besoin d’écrire.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("D’un signe de tête, il désigna une porte ouverte et ordonna à ses hommes :")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Détachez-leur les mains et enfermez-les.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Une fois que les deux hommes eurent délié Archer, ils le jetèrent sans ménagement de l’autre côté de la porte. Le capitaine se tourna vers Marshall.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Auriez-vous de la famille ou des amis susceptibles de payer votre rançon, disons, cinq mille livres ?")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("La somme était stupéfiante. Jadis, comme aspirant, Marshall touchait vingt-deux livres annuelles, sa solde était passée à cent livres depuis qu’il avait été promu lieutenant, mais jamais il ne pourrait envisager de rembourser une dette de cinq mille livres, même si sa carrière durait encore cinquante ans. Il lui faudrait sacrifier toutes ses primes de capture, sinon plus encore. Le capitaine Smith ne s’attendait certainement pas à une telle rançon quand il avait généreusement offert de la payer.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Vous devriez en parler à mon capitaine, répondit-il.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Smith aurait ainsi l’opportunité de changer d’avis ou de maintenir sa décision. Avec un peu de chance, peut-être s’échapperait-il avant d’avoir à se décider.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Soyez certain que je le ferai. Reposez-vous bien, lieutenant.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("La cellule était minuscule, moins de six mètres carrés, avec un plafond plus bas que la taille de Marshall – un mètre quatre-vingt. Il le remarqua parce qu’il heurta le bois brut de la tête en pénétrant à l’intérieur.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Son attention se concentra sur Archer, couché à plat ventre dans la paille qui couvrait le sol.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Davy ?")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Dans un coin de la cellule, Marshall trouva deux rouleaux de toile à voile, il en déplia un et étendit Archer sur ce lit de fortune. Il n’y voyait pas grand-chose, car la seule lumière provenait d’une lanterne accrochée devant les barreaux du hublot de la porte. Il ne paraissait y avoir aucun signe de blessures sur le gilet blanc d’uniforme de Davy, mais un peu de sang perlait à sa bouche, comme s’il s’était mordu la lèvre. Que diable… Archer n’avait jamais paru sujet à des crises d’apoplexie. Serait-ce un problème de cœur ? Ou bien les bandits l’avaient-ils assommé ?")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Davy, pour l’amour de Dieu, dites quelque chose !")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Mmm ?")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Marshall poussa un profond soupir, alors qu’il n’avait même pas réalisé retenir son souffle jusque-là. Archer s’agita et cligna des yeux, puis il se souleva sur un coude.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— William. Où sommes-nous ?")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Il regarda autour de lui. Il y avait trois seaux près de la porte, une coupe en bois posée à côté de l’un d’eux. Marshall vérifia le contenu du seau en question, préférant ne rien tenir pour acquis. Il s’agissait bien d’eau potable. Il en remplit la coupe qu’il offrit à Archer.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Nous sommes à bord d’un navire. L’")]), _c('span', {
    staticClass: "t13"
  }, [_vm._v("Insaisissable")]), _c('span', {
    staticClass: "t14"
  }, [_vm._v(", d’après ce que le chef des bandits nous a dit, même si, apparemment, elle porte actuellement un faux nom. Et le capitaine et l’équipage sont tous masqués.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Tout cela me paraît diablement bien organisé. Êtes-vous certain qu’il ne s’agit pas seulement d’un bal costumé ?")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Davy, que s’est-il passé ? Pourquoi étiez-vous inconscient ? Est-ce que tout va bien ?")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Archer posa sa tasse vide à côté de lui.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— À peu près. J’ai suivi vos conseils concernant ma respiration. J’ai tenté de penser à autre chose, par exemple voir combien de temps je pouvais retenir mon souffle, et tout d’un coup, je me suis évanoui. Et je viens juste de reprendre connaissance. Ce n’est guère héroïque, ajouta-t-il en haussant les épaules.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Il vaut beaucoup mieux être ingénieux qu’héroïque dans notre situation. Nous n’avions rien d’autre à faire qu’attendre de voir où tout cela nous mènera.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Où est le capitaine ?")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Marshall lui narra brièvement ce qui s’était passé à leur arrivée à bord.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Il m’a semblé descendre sept ou huit marches. D’après moi, ce navire est un peu plus petit que la")]), _vm._v(" "), _c('span', {
    staticClass: "t13"
  }, [_vm._v("Calypso")]), _c('span', {
    staticClass: "t14"
  }, [_vm._v(", mais c’est un peu difficile à déterminer à l’intérieur d’un baril.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Effectivement. Au moins, cette cellule est un peu plus vaste qu’un tonneau.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Archer se remit debout, prudemment, puis il fronça les sourcils en voyant qu’il touchait le plafond.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Morbleu, le plafond est bas !")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Certes, mais nous avons la place de nous étendre sans pour autant renverser notre provision d’eau. Ce pourrait être pire.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— La porte est verrouillée, bien sûr ?")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Il y a un cadenas à l’extérieur.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Marshall remarqua que la porte n’avait pas de poignée de leur côté. Il frappa du poing sur le panneau et entendit aussitôt des pas approcher. Un visage masqué s’insinua dans le hublot.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Ne touchez pas à la porte, sinon, vous le regretterez.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Marshall s’adressa à Archer sans se soucier du nouveau venu.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Et nous avons un garde. Un bâtard très amical.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Le visage disparut ; les pas s’éloignèrent, mais guère. Le garde devait se tenir hors de portée de ses prisonniers.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Archer fit le tour de la petite cellule, ses mains courant le long des murs. Marshall espérait que l’impatience de son compagnon s’apaiserait bientôt. Lui-même était déjà suffisamment nerveux.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— William, regardez !")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Quoi ?")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Il se leva et s’approcha d’Archer. Il découvrit alors une sorte d’évent – simple carré d’environ quarante-cinq centimètres de côté, coupé au milieu d’un barreau métallique vertical. Il y avait un volet extérieur dont les gonds permettaient une ouverture à angle variable. Il passa le bras suffisamment loin pour en sentir le contour, verrouillé par des vis en métal. Le panneau bougea cependant quand Marshall poussa dessus.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Je pense qu’il s’agit d’une sorte de volet obturateur, Davy, comme pour fermer une écoutille, mais en sens inverse. Nous ne pouvons rien voir à l’extérieur et ils la refermeront si un autre navire est suffisamment proche pour nous entendre.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Cela nous donne au moins de l’air frais.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Oui. Et quand il fera jour, nous vérifierons s’il nous est possible de jeter quelque chose à la mer.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Un message dans une bouteille ? s’enquit Archer, amusé.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Pourquoi pas, si nous en avions une. Et surtout si nos ravisseurs n’étaient pas les premiers à risquer de l’apercevoir, d’en haut. Je ne vois pas ce que nous pourrions faire d’utile pour le moment. L’aube ne devrait pas tarder. Le soleil se lève vers cinq heures et demie.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Comme pour lui confirmer ces estimations, la cloche de bord sonna une fois, son écho leur parvenant par la bouche d’aération.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Nous pouvons donc dormir une heure. Et si nous n’y parvenons pas, nous utiliserons ce temps libre pour réviser les problèmes de navigation de votre examen.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Il savait combien Archer détestait les mathématiques, même s’il était relativement compétent dans ce domaine.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Voilà de quoi me remonter le moral ! répondit Archer.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Il réaménagea la paille qui se trouvait sur le sol, puis ajouta :")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— On dirait qu’ils avaient prévu de mettre ici du bétail, pas des prisonniers. Ils auraient quand même pu nous fournir deux hamacs !")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Nous ne resterons pas ici assez longtemps pour en avoir besoin, déclara Marshall qui essayait de paraître confiant.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("D’un regard, Archer lui indiqua qu’il n’était pas dupe, mais il hocha la tête.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Croyez-vous que nous devrions monter la garde à tour de rôle ?")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Pas pour le moment, non. Prenez du repos, Davy. Nous avons passé une bien mauvaise journée.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Nous sommes déjà demain.")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("Puis, avec un sourire penaud, il ajouta :")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t14"
  }, [_vm._v("— Joyeux anniversaire, Will.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47fbe3e9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/009.vue
// module id = 78
// module chunks = 0